 <template>
    <div id="content">
        <form>
            <div class="inner">
                <h1 v-translate>Základní konfigurace</h1>
            </div>
            <div class="responsiveTabs r-tabs" v-if="entity">
                <div class="tabs_content" id="tab-1">
                  <section>
                      <div class="left">
                          <h2 v-translate>Obecné nastavení</h2>
                        <p v-translate>Device Log Viewer URL musí obsahovat: {dashboard_uid}</p>
                      </div>
                      <div class="right">
                        <text-input :disabled="!$_updateActionAllowed" id="contact_email" v-model="entity.contact_email" ref="contactemailref"><translate class="translate">Kontaktní email</translate></text-input>
                      </div>
                    <div class="right">
                      <text-input :required="true" :disabled="!$_updateActionAllowed" id="backoffice_url" v-model="entity.backoffice_url" ref="backofficeurlref"><translate class="translate">Url backoffice</translate></text-input>
                    </div>
                    <div class="right">
                      <text-input :required="true" :disabled="!$_updateActionAllowed" id="primary_server_hostname" v-model="entity.primary_server_hostname" ref="primaryserverhostnameref"><translate class="translate">Hostname primárního serveru</translate></text-input>
                    </div>
                    <div class="right">
                      <text-input :disabled="!$_updateActionAllowed" id="devicelogviewerulr" v-model="entity.device_log_viewer_url" ref="devicelogviewerulrref"><translate class="translate">Device Log Viewer URL</translate></text-input>
                    </div>
                  </section>
                  <section>
                    <div class="left">
                      <h2 v-translate>Nastavení obsahu</h2>

                      <p v-translate>Sufix může obsahovat: {channel_id}</p>
                    </div>
                    <div class="right">
                      <text-input :disabled="!$_updateActionAllowed" id="cms_url" v-model="entity.cms_url" :required="true" ref="cmsurlref"><translate class="translate">CMS URL</translate></text-input>
                      <text-input :disabled="!$_updateActionAllowed" id="red_cache_url" v-model="entity.red_cache_url" :required="true" ref="redcacheurlref"><translate class="translate">RedCache URL</translate></text-input>
                      <text-input :disabled="!$_updateActionAllowed" id="channel_logo_source_url" v-model="entity.channel_logo_source_url" :required="true" ref="channellogosourceurlref"><translate class="translate">Zdrojová URL log kanálů</translate></text-input>
                      <text-input :disabled="!$_updateActionAllowed" id="channel_logo_source_url_sufix" v-model="entity.channel_logo_source_url_sufix" :required="true" ref="channellogosourceurlsufirref"><translate class="translate">Sufix URL log kanálů</translate></text-input>
                      <text-input :disabled="!$_updateActionAllowed" id="channel_logo_source_url_1080_sufix" v-model="entity.channel_logo_source_url_1080_sufix" :required="true" ref="channellogosourceurl1080sufixref" :help-text="$gettext('1080')"><translate class="translate">Sufix URL log kanálů</translate></text-input>
                      <text-input :disabled="!$_updateActionAllowed" id="channel_logo_source_url_720_sufix" v-model="entity.channel_logo_source_url_720_sufix" :required="true" ref="channellogosourceurl720sufixref" :help-text="$gettext('720')"><translate class="translate">Sufix URL log kanálů</translate></text-input>
                      <text-input :disabled="!$_updateActionAllowed" id="channel_logo_source_url_colored_sufix" v-model="entity.channel_logo_source_url_colored_sufix" :required="true" ref="channellogosourceurlcoloredsufixref" :help-text="$gettext('Barevné')"><translate class="translate">Sufix URL log kanálů</translate></text-input>

                      <div class="field_left">
                        <text-input :disabled="!$_updateActionAllowed" id="default_preoverlap" v-model="entity.default_preoverlap" :required="true" ref="defaultpreoverlapref"><translate class="translate">Výchozí preoverlap (s)</translate></text-input>
                        <text-input :disabled="!$_updateActionAllowed" id="default_postoverlap" v-model="entity.default_postoverlap" :required="true" ref="defaultpostoverlapref"><translate class="translate">Výchozí postoverlap (s)</translate></text-input>
                        <text-input :disabled="!$_updateActionAllowed" id="pvr_lifetime_in_days" v-model="entity.pvr_lifetime_in_days" ref="defaultpvrlifetimeindaysref"><translate class="translate">Počet dní pro uchování nahrávek</translate></text-input>
                      </div>
                      <div class="field_right">
                        <text-input :disabled="!$_updateActionAllowed" id="maximum_epg_view_back_in_hours" v-model="entity.maximum_epg_view_back_in_hours" :required="true" ref="maximumepviewbackinhoursref"><translate class="translate">EPG zpět (h)</translate></text-input>
                        <text-input :disabled="!$_updateActionAllowed" id="maximum_epg_view_forward_in_hours" v-model="entity.maximum_epg_view_forward_in_hours" :required="true" ref="maximumepgviewforwardinhoursref"><translate class="translate">EPG vpřed (h)</translate></text-input>
                      </div>
                    </div>

                  </section>
                  <section>
                    <div class="left">
                      <h2 v-translate>Supervisor obsahu</h2>

                      <p v-translate>Sufix může obsahovat: {device_token}, {channel_id}, {start}, {end}</p>
                    </div>
                    <div class="right">
                      <text-input :disabled="!$_updateActionAllowed" id="content_source_supervisor_url" v-model="entity.content_source_supervisor_url" :required="true" ref="contentsourcesupervisorurlref"><translate class="translate">URL supervisora obsahu</translate></text-input>
                      <text-input :disabled="!$_updateActionAllowed" id="content_source_supervisor_generate_url_sufix" v-model="entity.content_source_supervisor_generate_url_sufix" :required="true" ref="contentsourcesupervisorgenerateurlsufixref"><translate class="translate">Sufix URL supervisora obsahu</translate></text-input>
                    </div>
                  </section>
                  <section>
                    <div class="left">
                      <h2 v-translate>Peoplemeter</h2>
                    </div>
                    <div class="right">
                      <text-input :disabled="!$_updateActionAllowed" id="peoplemeter_url" v-model="entity.peoplemeter_url" :required="true" ref="peoplemeterurlref"><translate class="translate">URL peoplemeteru</translate></text-input>
                    </div>
                  </section>
                  <section>
                    <div class="left">
                      <h2 v-translate>Thumbnailer (starý)</h2>

                      <p v-translate>Sufix může obsahovat: {channel_id}, {utc_start_timestamp}, {offset_seconds}, {protocol_name}</p>
                    </div>
                    <div class="right">
                      <text-input :disabled="!$_updateActionAllowed" id="stream_thumbnails_source_url" v-model="entity.stream_thumbnails_source_url" :required="true" ref="streamthumbnailssourceurlref"><translate class="translate">URL thumbnaileru</translate></text-input>
                      <text-input :disabled="!$_updateActionAllowed" id="stream_thumbnails_url_suffix_template" v-model="entity.stream_thumbnails_url_suffix_template" :required="true" ref="streamthumbnailsurlsuffixtemplateref"><translate class="translate">Sufix URL thumbnaileru</translate></text-input>
                    </div>
                  </section>

                  <section>
                    <div class="left">
                      <h2 v-translate>Thumbnailer (nový)</h2>

                      <p v-translate>Sufix posledního může obsahovat: {device_token}, {channel_id}, {offset_seconds}, {width}</p>
                      <p v-translate>Sufix nejbližšího může obsahovat: {device_token}, {channel_id}, {width}, {broadcast_start}, {broadcast_end}, {offset}, {live_playback}, {reply}</p>
                    </div>
                    <div class="right">
                      <text-input :disabled="!$_updateActionAllowed" id="stream_thumbnailer_url" v-model="entity.stream_thumbnailer_url" :required="true" ref="streamthumbnailerurlref"><translate class="translate">URL thumbnaileru</translate></text-input>
                      <text-input :disabled="!$_updateActionAllowed" id="stream_thumbnailer_url_latest_suffix_template" v-model="entity.stream_thumbnailer_url_latest_suffix_template" :required="true" ref="streamthumbnailerurllatestsuffixtemplateref"><translate class="translate">Sufix URL pro získání posledního náhledu</translate></text-input>
                      <text-input :disabled="!$_updateActionAllowed" id="stream_thumbnailer_url_nearest_suffix_template" v-model="entity.stream_thumbnailer_url_nearest_suffix_template" :required="true" ref="streamthumbnailerurlnearestsuffixtemplateref"><translate class="translate">Sufix URL pro získání nejbližšího náhledu</translate></text-input>
                    </div>
                  </section>
                  <section>
                    <div class="left">
                      <h2 v-translate>Videotéka</h2>

                      <p v-translate>Šablona URL pro playlisty videotéky může obsahovat zástupné symboly: {device_token}, {id_vod_video}, {stream_profiles}, {shaping}, {extra_audio}, {extra_subs}, {auth_token}, {protocol_prefix}, {protocol_port}, {expiration}, {signature}</p>
                      <p v-translate>Hodnoty query parametrů pro náhledy mohou obsahovat zástupné symboly: {device_token}, {stream_profiles}, {expiration}, {signature}</p>
                    </div>
                    <div class="right">
                      <text-input :disabled="!$_updateActionAllowed" id="vod_logo_url_path" v-model="entity.vod_logo_url_path" :required="true" ref="vodlogourlpathref"><translate class="translate">URL cesta pro loga poskytovatelů videí pro zařízení</translate></text-input>
                      <text-input :disabled="!$_updateActionAllowed" id="vod_playlist_url_template" v-model="entity.vod_playlist_url_template" :required="true" ref="vodplaylisturltemplateref"><translate class="translate">Šablona URL pro playlisty videotéky</translate></text-input>
                      <text-input :disabled="!$_updateActionAllowed" id="vod_thumbnail_url_template" v-model="entity.vod_thumbnail_url_template" :required="true" ref="vodthumbnailurltemplateref"><translate class="translate">Šablona URL pro náhledy videotéky</translate></text-input>
                      <div class="field">
                      <JSONTextareaInput
                            v-model="entity.vod_thumbnail_query_params"
                            id="vod_thumbnail_query_params"
                            rows="6"
                            :disabled="!$_updateActionAllowed"
                        >
                          <translate class="translate">Query parametry pro náhledy</translate>
                        </JSONTextareaInput>
                    </div>
                    </div>
                  </section>
                  <section>
                    <div class="left">
                      <h2 v-translate>Regionální nastavení</h2>
                    </div>
                    <div class="right">
                      <div class="field_left">
                        <select-box id="idcurrency"
                                    ref="idecurrencyref"
                                    v-model="entity.id_currency"
                                    :options="currencyOptions"
                                    :disabled="!$_updateActionAllowed"
                        >
                          <translate class="translate">Výchozí měna</translate>
                        </select-box>
                      </div>
                    </div>
                  </section>
                  <section>
                    <div class="left">
                      <h2 v-translate>Nastavení změnové metody</h2>
                    </div>
                    <div class="right">
                      <div class="field_left">
                        <text-input :disabled="!$_updateActionAllowed" id="modified_since_threshold_hours" v-model="entity.modified_since_threshold_hours" :required="true" ref="modifiedsincethresholdhoursref"><translate class="translate">Maximální platnost dat (h)</translate></text-input>
                      </div>
                      <div class="field_right">
                        <text-input :disabled="!$_updateActionAllowed" id="next_check_fixed_seconds" v-model="entity.next_check_fixed_seconds" :required="true" ref="nextcheckfixedsecondsref"><translate class="translate">Fixní část dalšího volání (s)</translate></text-input>
                        <text-input :disabled="!$_updateActionAllowed" id="next_check_variable_seconds" v-model="entity.next_check_variable_seconds" :required="true" ref="nextcheckvariablesecondsref"><translate class="translate">Variabilní část dalšího volání (s)</translate></text-input>
                      </div>
                    </div>
                  </section>
                  <section>
                    <div class="left">
                      <h2 v-translate>Nastavení cache</h2>
                    </div>
                    <div class="right">
                      <div class="field_left">
                        <text-input :disabled="!$_updateActionAllowed" id="delete_cache_threshold" v-model="entity.delete_cache_threshold" :required="true" ref="deletecachethresholdref"><translate class="translate">Threshold počtu zařízení pro velké změny</translate></text-input>
                        <text-input :disabled="!$_updateActionAllowed" id="channel_group_change_batch_size" v-model="entity.channel_group_change_batch_size" :required="true" ref="channelgroupchangebatchsizeref"><translate class="translate">Počet změněných skupin kanálů při hromadné změně za 1 minutu</translate></text-input>
                      </div>
                      <div class="field_right">
                        <text-input :disabled="!$_updateActionAllowed" id="above_threshold_delete_cache_count_per_minute" v-model="entity.above_threshold_delete_cache_count_per_minute" :required="true" ref="abovethresholddeletecachecountperminuteref"><translate class="translate">Maximální počet zařízení, mazaných v rámci velkých změn za 1 minutu</translate></text-input>
                        <text-input :disabled="!$_updateActionAllowed" id="within_threshold_delete_cache_count_per_minute" v-model="entity.within_threshold_delete_cache_count_per_minute" :required="true" ref="withinhresholddeletecachecountperminuteref"><translate class="translate">Maximální počet zařízení, mazaných v rámci malých změn za 1 minutu</translate></text-input>
                      </div>
                    </div>
                  </section>
                  <section>
                    <div class="left">
                        <h2 v-translate>Nastavení WebDav</h2>
                    </div>
                    <div class="right">
                        <div class="field_left">
                            <text-input :disabled="!$_updateActionAllowed" id="webdav_host" v-model="entity.webdav.host" :required="true" ref="webdavhostref"><translate class="translate">Host</translate></text-input>
                            <text-input :disabled="!$_updateActionAllowed" id="webdav_home_folder" v-model="entity.webdav.home_folder" :required="true" ref="webdavhomefolder"><translate class="translate">Domovská složka</translate></text-input>
                        </div>
                        <div class="field_right">
                            <text-input :disabled="!$_updateActionAllowed" id="webdav_user" v-model="entity.webdav.user" :required="true" ref="webdavuserref"><translate class="translate">Uživatelské jméno</translate></text-input>
                            <text-input :disabled="!$_updateActionAllowed" id="webdav_password" v-model="entity.webdav.password" :required="true" ref="webdavpassword"><translate class="translate">Heslo</translate></text-input>
                        </div>
                    </div>
                  </section>
                  <section>
                    <div class="left">
                        <h2 v-translate>Nastavení API</h2>
                    </div>
                    <div class="right">
                        <div class="field_left">
                            <text-input id="backend_api_key" v-model="entity.backend_api_key" :required="true" :disabled="true" ref="backendapikeyref"><translate class="translate">Backend API Key</translate></text-input>
                        </div>
                      <div class="field_right">
                        <text-input id="backoffice_api_key" v-model="entity.backoffice_api_key" :required="true" ref="backofficeapikeyref" :helpText="$gettext('Pro komunikaci s API jiných systémů jako např. CMS')"><translate class="translate">Backoffice API Key</translate></text-input>
                      </div>
                    </div>
                  </section>
                  <section>
                    <div class="left">
                      <h2 v-translate>Nastavení promazávání zařízení</h2>
                    </div>
                    <div class="right">
                      <div class="field">
                        <delete-unused-devices-by-type-list
                            :value="entity.delete_unused_devices_by_type"
                            @input="entity.delete_unused_devices_by_type = arguments[0]"
                            :is-editable="$_updateActionAllowed"
                        />
                      </div>
                    </div>
                  </section>
                  <section>
                    <div class="left">
                      <h2 v-translate>Nastavení autentifikace</h2>
                    </div>
                    <div class="right">
                      <div class="field_left">
                        <text-input :disabled="!$_updateActionAllowed" id="session_token_expiration_minutes" v-model="entity.session_token_expiration_minutes" :required="true" ref="sessiontokenexpirationminutesref"><translate class="translate">Čas vypršení API session tokenu v minutách</translate></text-input>
                      </div>
                      <div class="field_right">
                        <text-input :disabled="!$_updateActionAllowed" id="session_token_expiration_minutes" v-model="entity.challenge_token_expiration_minutes" :required="true" ref="challengetokenexpirationminutesref"><translate class="translate">Čas vypršení challenge tokenu pro párování zařízení v minutách</translate></text-input>
                      </div>
                      <div class="field_left">
                        <text-input :disabled="!$_updateActionAllowed" id="subscriber_token_expiration_days" v-model="entity.subscriber_token_expiration_days" :required="true" ref="subscribertokenexpirationdaysref"><translate class="translate">Čas vypršení subscriber session tokenu ve dnech</translate></text-input>
                      </div>
                    </div>
                  </section>
                  <section>
                    <div class="left">
                      <h2 v-translate>Nastavení reklam</h2>
                    </div>
                    <div class="right">
                      <div class="field_left">
                        <text-input :disabled="!$_updateActionAllowed" id="advertisement_middleware_component_api_url" v-model="entity.advertisement_middleware_component_api_url" :required="true" ref="advertisementmiddlewarecomponentapiurlref"><translate class="translate">Url středové komponenty s reklamním API</translate></text-input>
                      </div>
                    </div>
                  </section>
                  <section>
                    <div class="left">
                      <h2 v-translate>Nastavení oblíbených pořadů</h2>
                    </div>
                    <div class="right">
                      <div class="field_left">
                        <checkbox-input
                            :disabled="!$_updateActionAllowed"
                            id="allowfavoriteshows"
                            v-model="entity.allow_favorite_shows"
                        >
                          <translate class="translate">Povolit ukládání oblíbených pořadů</translate>
                        </checkbox-input>
                        <text-input
                            id="maximum_favorite_shows"
                            v-model="entity.maximum_favorite_shows"
                            :required="true"
                            ref="maximumfavoriteshowsref"
                            :disabled="!enabledMaximumFavoriteShows || !$_updateActionAllowed"
                        >
                          <translate class="translate">Maximální počet uložených oblíbených pořadů</translate></text-input>
                      </div>
                    </div>
                  </section>
                  <section>
                    <div class="left">
                      <h2 v-translate>Nastavení geoblockingu</h2>
                    </div>
                    <div class="right">
                      <div class="field_left">
                        <text-input id="geoblockingcountrycodes"
                                    ref="geoblockingcountrycodesref"
                                    v-model="entity.geoblocking_country_codes"
                                    :disabled="!$_updateActionAllowed"
                                    :help-text="$gettext('kódy států ve formátu ISO 3166-1 alpha-3 oddělené čárkami')"
                        >
                          <translate class="translate">Seznam povolených států</translate>
                        </text-input>
                        </div>
                    </div>
                      <GeoblockingPrivateIpList
                          :is-editable="$_updateActionAllowed"
                      />
                  </section>
                  <section>
                    <div class="left">
                      <h2 v-translate>Nastavení reportingu</h2>
                    </div>
                    <div class="right">
                      <div class="field_left">
                        <text-input
                            id="full_report_frequency"
                            v-model="entity.full_report_frequency"
                            :required="true"
                            ref="fullreportfrequencyref"
                            :help-text="$gettext('Každý N-tý report bude vygenerován jako plný, ostatní pouze jako rozdílové.')"
                        ><translate class="translate">Frekvence plných reportů</translate></text-input>
                      </div>
                      <div class="field_right">
                        <checkbox-input
                            id="report_subscribers_after_first_month"
                            v-model="entity.report_subscribers_after_first_month"
                            ref="reportsubscribersafterfirstmonthref"
                            :help-text="$gettext('Naposledy změněno')+': '+reportSubscriberAfterFirstMonthLastChange"
                        ><translate class="translate">Reportovat nové odběratele od 1. dne následujícího měsíce</translate></checkbox-input>
                      </div>
                      <div class="field_left">
                        <select-box
                            id="report_expiration_months"
                            ref="reportexpirationmonthsref"
                            :options="reportExpirationMonthsOptions"
                            :help-text="$gettext('Ze starších reportů bude zachován jen poslední plný report v měsící.')"
                            v-model="entity.report_expiration_months"
                        >
                          <translate class="translate">Doba expirace reportů</translate>
                        </select-box>
                      </div>
                    </div>
                  </section>
                  <section>
                    <div class="left">
                      <h2 v-translate>Nastavení výchozích uživatelských profilů</h2>
                    </div>
                    <div class="right">
                      <div class="field_left">
                        <checkbox-input
                            id="create_default_child_subscriber_profile"
                            v-model="entity.create_default_child_subscriber_profile"
                            ref="createdefaultchildsubscriberprofileref"
                        ><translate class="translate">Vytvářet výchozí dětský profil</translate></checkbox-input>
                      </div>
                      <div class="field_left">
                        <text-input
                            id="default_subscriber_profile_name"
                            v-model="entity.default_subscriber_profile_name"
                            :required="true"
                            ref="defaultsubscriberprofilenameref"
                        ><translate class="translate">Název výchozího uživatelského profilu</translate></text-input>
                      </div>
                      <div class="field_right">
                        <text-input
                            id="default_child_subscriber_profile_name"
                            v-model="entity.default_child_subscriber_profile_name"
                            :required="true"
                            ref="defaultchildsubscriberprofilenameref"
                        ><translate class="translate">Název výchozího dětského uživatelského profilu</translate></text-input>
                      </div>
                    </div>
                  </section>
                  <section>
                    <div class="left">
                      <h2 v-translate>Nastavení bootserveru</h2>
                    </div>
                    <div class="right">
                      <div class="field_left">
                        <text-input
                            id="bootserver_file_root_url"
                            v-model="entity.bootserver_file_root_url"
                            :required="true"
                            ref="bootserverfilerooturl"
                        ><translate class="translate">URL bootserveru</translate></text-input>
                      </div>
                      <div class="field_right">
                        <text-input
                            id="bootserver_default_brand_code"
                            v-model="entity.bootserver_default_brand_code"
                            :required="true"
                            ref="bootserverdefaultbrandcoderef"
                        ><translate class="translate">Výchozí kód brandu</translate></text-input>
                      </div>
                    </div>
                  </section>
                  <section>
                    <div class="left">
                      <h2 v-translate>Nastavení změny PIN</h2>
                    </div>
                    <div class="right">
                      <div class="field_left">
                        <checkbox-input
                            id="force_subscriber_pin_change"
                            v-model="entity.force_subscriber_pin_change"
                            ref="forcesubscriberpinchangeref"
                        ><translate class="translate">Vynutit změnu PIN odběratele</translate></checkbox-input>
                      </div>
                      <div class="field_left">
                        <text-input
                            id="maximal_pin_failed_attempts"
                            v-model="entity.maximal_pin_failed_attempts"
                            :required="true"
                            ref="maximalpinfailedattemptsref"
                        ><translate class="translate">Maximální počet nesprávných zadání PIN</translate></text-input>
                      </div>
                      <div class="field_right">
                        <text-input
                            id="pin_cooldown_in_minutes"
                            v-model="entity.pin_cooldown_in_minutes"
                            :required="true"
                            ref="pincooldowninminutesref"
                        ><translate class="translate">Prodleva po maximálním počtu nesprávných zadání PIN</translate></text-input>
                      </div>
                    </div>
                  </section>

                </div>
              <section class="buttons" v-if="$_updateActionAllowed">
                <p>
                  <input
                      :class="['btn', {btn_inactive: !isFormValid}]"
                         type="submit"
                         :value="'Uložit' | translate"
                         @click.stop.prevent="setNewPlatformConfiguration"
                         :disabled="!isFormValid"
                  >
                </p>
              </section>
            </div>
        </form>
    </div>
</template>

<script>
	import TextInput from "@/components/common/TextInput"
  import GeoblockingPrivateIpList from "../../common/GeoblockingPrivateIpList.vue";

	import message from "@/components/mixins/message"
  import JSONTextareaInput from "../../common/JSONTextareaInput.vue";
  import DeleteUnusedDevicesByTypeList from "./DeleteUnusedDevicesByTypeList.vue";

	export default {
		name: "AdminConfigurationDetail",
		components: { DeleteUnusedDevicesByTypeList, JSONTextareaInput, TextInput, GeoblockingPrivateIpList},
		mixins: [message],
		created(AdminConfigurationService, CurrencyService) {
			this.adminConfigurationService = AdminConfigurationService
      this.currencyService = CurrencyService;
			this.getCurrentAdminConfiguration()
      this.currencyService.getEntitiesForSelectBox({})
          .then((data) => {
            this.currencyOptions = data['currencies'];
          })
		},
		data() {
			return {
				entity: {
          id_currency: null,
          webdav: {
            user: null,
            password: null,
            host: null,
            home_folder: null,
          },
        },
        currencyOptions: [],
        disallowedAdminConfigurationParts: [
          'reset_password_settings',
          'timestamp_created',
          'timestamp_updated',
          'user_created_id',
          'user_updated_id',
          'user_created',
          'user_updated',
          'date_created',
          'date_updated',
          'report_subscribers_after_first_month_last_change',
        ]
			}

		},
		computed: {
      enabledMaximumFavoriteShows(){
        return this.entity.allow_favorite_shows;
      },
			isFormValid() {
        return true;
			},
      reportSubscriberAfterFirstMonthLastChange(){
        return this.entity.report_subscribers_after_first_month_last_change ? this.$_datetime_format(this.entity.report_subscribers_after_first_month_last_change) : this.$gettext("Zatím nezměněno");
      },
      reportExpirationMonthsOptions() {
        return [
          {id: null, text: this.$gettext('Nikdy')},
          {id: 6, text: this.$gettext('6 měsíců')},
          {id: 12, text: this.$gettext('12 měsíců')},
          {id: 18, text: this.$gettext('18 měsíců')},
          {id: 24, text: this.$gettext('24 měsíců')},
          {id: 30, text: this.$gettext('30 měsíců')},
          {id: 36, text: this.$gettext('36 měsíců')},
        ]
      }
		},
		methods: {
			getCurrentAdminConfiguration() {
				this.setLoadingMessage()
				return this.adminConfigurationService.getEntity()
					.then(data => {
						this.emptyMessage()
						this.entity = data.admin_configuration
					})
					.catch(function (error) {
						this.setErrorMessage(error['error_message'])
					}.bind(this))
			},
			setNewPlatformConfiguration() {
        this._resetForm();
        let params = {...this.entity};

        this.disallowedAdminConfigurationParts.forEach((value) => {
          delete params[value];
        });

				this.setLoadingMessage()
				this.adminConfigurationService.updateEntity(params)
					.then(() => {
            this.getCurrentAdminConfiguration().then(() => {
              this.setSuccessMessage(this.$gettext('Úspěšně uloženo.'))
            });
					})
					.catch(function (error) {
            this._showValidationErrors(error);
					}.bind(this))
			},
      _showValidationErrors(error) {
        let validationError = error.error_message;

        error.validation_errors && error.validation_errors.forEach((message) => {
          if (message === "Configuration's 'contact_email' must be valid email.") {
            this.$refs['contactemailref'].setForcedInvalid(true, this.$gettext("Neplatný email"));
          } else if (message === "Primary server hostname is missing.") {
            this.$refs['primaryserverhostnameref'].setForcedInvalid(true, this.$gettext("Neplatná hodnota"));
          } else if (message === "Default preoverlap must be number.") {
            this.$refs['defaultpreoverlapref'].setForcedInvalid(true, this.$gettext("Hodnota musí být číslo"));
          } else if (message === "Default postoverlap must be number.") {
            this.$refs['defaultpostoverlapref'].setForcedInvalid(true, this.$gettext("Hodnota musí být číslo"));
          } else if (message === "Default preoverlap value must be greater or equals to 0.") {
            this.$refs['defaultpreoverlapref'].setForcedInvalid(true, this.$gettext("Hodnota musí být >= 0"));
          } else if (message === "Default postoverlap value must be greater or equals to 0.") {
            this.$refs['defaultpostoverlapref'].setForcedInvalid(true, this.$gettext("Hodnota musí být >= 0"));
          } else if (message === "Configuration's maximum maximum EPG view back in hours must be number.") {
            this.$refs['maximumepviewbackinhoursref'].setForcedInvalid(true, this.$gettext("Hodnota musí být číslo"));
          } else if (message === "Value max_epg_view_back_in_hours can't be less then biggest operator configuration max_epg_view_back_in_hours") {
            this.$refs['maximumepviewbackinhoursref'].setForcedInvalid(true, this.$gettext("Hodnota nesmí být nižší než nejvyšší operátorské nastavení."));
          } else if (message === "Configuration's maximum EPG view forward in hours must be number.") {
            this.$refs['maximumepgviewforwardinhoursref'].setForcedInvalid(true, this.$gettext("Hodnota musí být číslo"));
          } else if (message === "Value max_epg_view_forward_in_hours can't be less then biggest operator configuration max_epg_view_forward_in_hours") {
            this.$refs['maximumepgviewforwardinhoursref'].setForcedInvalid(true, this.$gettext("Hodnota nesmí být nižší než nejvyšší operátorské nastavení."));
          } else if (message === "Modified since threshold must be greater than 0.") {
            this.$refs['modifiedsincethresholdhoursref'].setForcedInvalid(true, this.$gettext("Hodnota musí být > 0"));
          } else if (message === "Next check fixed part must be at least 60.") {
            this.$refs['nextcheckfixedsecondsref'].setForcedInvalid(true, this.$gettext("Hodnota musí být >= 60"));
          } else if (message === "Next check variable part must be at least 60.") {
            this.$refs['nextcheckvariablesecondsref'].setForcedInvalid(true, this.$gettext("Hodnota musí být >= 60"));
          } else if (message === "Delete device cache threshold must be at least 1.") {
            this.$refs['deletecachethresholdref'].setForcedInvalid(true, this.$gettext("Hodnota musí být > 0"));
          } else if (message === "Above threshold delete cache count per minute must be at least 1000.") {
            this.$refs['abovethresholddeletecachecountperminuteref'].setForcedInvalid(true, this.$gettext("Hodnota musí být >= 1000"));
          } else if (message === "Within threshold delete count per minute must be at least 1000.") {
            this.$refs['withinhresholddeletecachecountperminuteref'].setForcedInvalid(true, this.$gettext("Hodnota musí být >= 1000"));
          } else if (message === "Modified since threshold must be integer.") {
            this.$refs['modifiedsincethresholdhoursref'].setForcedInvalid(true, this.$gettext("Hodnota musí být číslo"));
          } else if (message === "Next check fixed part must be integer.") {
            this.$refs['nextcheckfixedsecondsref'].setForcedInvalid(true, this.$gettext("Hodnota musí být číslo"));
          } else if (message === "Next check variable part must be integer.") {
            this.$refs['nextcheckvariablesecondsref'].setForcedInvalid(true, this.$gettext("Hodnota musí být číslo"));
          } else if (message === "Delete device cache threshold must be integer.") {
            this.$refs['deletecachethresholdref'].setForcedInvalid(true, this.$gettext("Hodnota musí být číslo"));
          } else if (message === "Above threshold delete cache count per minute must be integer.") {
            this.$refs['abovethresholddeletecachecountperminuteref'].setForcedInvalid(true, this.$gettext("Hodnota musí být číslo"));
          } else if (message === "Within threshold delete count per minute must be integer.") {
            this.$refs['withinhresholddeletecachecountperminuteref'].setForcedInvalid(true, this.$gettext("Hodnota musí být číslo"));
          } else if (message === "Backend API key is too short - 6 letters at least are required.") {
            this.$refs['backendapikeyref'].setForcedInvalid(true, this.$gettext('Minimální délka Backend API klíče je 6 znaků.'));
          } else if (message === "CMS url is too short - 5 letters at least are required.") {
            this.$refs['cmsurlref'].setForcedInvalid(true, this.$gettext('Zadejte platnou URL pro CMS.'));
          } else if (message === "Advertisement middleware component api url is too short - 2 letters at least are required.") {
            this.$refs['advertisementmiddlewarecomponentapiurlref'].setForcedInvalid(true, this.$gettext("Url nesmí být kratší než 2 znaky"));
          } else {
            validationError = message;
          }
        });

        this.setErrorMessage(this.$gettext(validationError));
      },
      _resetForm() {
        for(let key of Object.keys(this.$refs)) {
          if (key.endsWith("ref")) {
            this.$refs[key].setForcedInvalid(false);
          }
        }
      }
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/views/adminConfiguration/AdminConfigurationDetail.vue